<template>
    <div class="message-comment">
        <template v-if="comment && comment !== ''">
            <div>
                Comments by {{ getProviderName }}&nbsp; &#183; 
                <span class="comment-date">
                    &nbsp;{{ formatDate(commentTime) }}, {{ formatTime(commentTime) }}
                </span>
            </div>
            <div class="comment-content">
                {{ comment }}
            </div>
        </template>
        <template v-else>
            <div v-if="formActive">
                <div>Add comment</div>
                <el-input type="textarea" 
                    :rows="3"
                    v-model="userComment">
                </el-input>
                <div class="comment-buttons">
                    <el-button type="text" @click="cancelComment">
                        Cancel
                    </el-button>
                    <el-button type="primary" @click="$emit('add-comment', userComment)" 
                        :disabled="userComment.length == 0 || commenting">
                        {{ commenting ? 'Saving...' : 'Save' }}
                    </el-button>
                </div>
            </div>
            <el-button type="text" v-else
                @click="formActive = true"
                class="add-comment">
                <i class="el-icon-plus"></i>
                Add Comment
            </el-button>
        </template>
    </div>
</template>

<script>
import formatTime from '@/module/util/format-time'
import formatDate from '@/module/util/format-date'
import { mapGetters } from 'vuex'
export default {
    name: 'patient-message-card-comment',

    props: {
        comment: {
            type: String,
            required: true
        },
        commenting: {
            type: Boolean,
            required: true
        },
        commentTime: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            formActive: false,
            userComment: ''
        }
    },

    methods: {
        formatTime,
        formatDate,
        cancelComment() {
            this.formActive = false
            this.userComment = ''
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getProviderName',
        ]),
    }
}
</script>

<style lang="scss" scoped>
.message-comment {
    padding: 12px 16px;
    background-color: #c1deff;
    font-size: 14px;
    font-weight: bold;
    color: #215898;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    .comment-date {
        font-size: 12px;
        font-weight: normal;
        color: #215898;
        opacity: 0.6;
    }
    .comment-content {
        padding-top: 6px;
        font-weight: normal;
    }
    .el-textarea {
        margin-top: 7px;
    }
    .comment-buttons {
        margin-top: 10px;
        text-align: right;
        .el-button {
            padding: 5px;
            width: 50px;
            border-radius: 12px;
            font-size: 14px;
            margin-left: 15px;
        }
        .el-button--primary {
            background-color: #3572b9;
            border: none;
            width: 80px;
            font-size: 14px;
        }
        .el-button--text {
            color: #215898;
            text-decoration: underline;
        }
    }
    .add-comment {
        font-size: 14px;
        padding: 2px;
        font-weight: bold;
        color: #215898;
    }
}
</style>